// The read behind each requisition section. `#requisitions/<R>/<key>` draws a section whose screen opens with the read
// named here, and a reader whose manifest lacks it lands on "We can't show that page", Not found or a role refusal.
// App.tsx's landing gates hold the top-level views only, so a link or a tab into a section checks this one map against
// `can` before it is drawn: the Search Readiness and Req health rows in the requisition's rail (F-11) and the V1 section
// strip (F-12). A section the map does not name has no gate here, as a view with no landing gate has none in App.tsx,
// and a record under a section (a candidate, a debrief room) carries its own seat rule and its own refusal.

/** Each section and the reads its screen opens with (intake is intake.open, as the requisition's Intake tab checks);
 * any one of them opens it. */
export const SUB_ROUTE_READS: Readonly<Record<string, readonly string[]>> = {
  intake: ["intake.open"],
  candidates: ["candidate.list"],
  packets: ["packet.readiness_check"],
  debriefs: ["debrief.list_mine"],
  offer: ["disposition.open_worklist"],
  concerns: ["conduct.list_mine", "conduct.list"],
  access: ["access.list"],
  timeline: ["timeline.requisition"],
  activity: ["audit.query"],
};

/** Whether the reader can open a requisition section: one of its reads is theirs, or the map names none. */
export function canOpenSubRoute(key: string, can: (tool: string) => boolean): boolean {
  return !Object.hasOwn(SUB_ROUTE_READS, key) || (SUB_ROUTE_READS[key] ?? []).some(can);
}

/** The section of `#requisitions/<R>/<key>` (its query aside), or undefined for the requisition's page, a record under
 * a section and every other route. */
export function subRouteOf(href: string): string | undefined {
  return /^#requisitions\/[^/?]+\/([^/?]+)(?:\?.*)?$/.exec(href)?.[1];
}

/** Whether the reader can open a route: a requisition section by its reads; any other route keeps its own rule. */
export function canOpenRoute(href: string, can: (tool: string) => boolean): boolean {
  const key = subRouteOf(href);
  return key === undefined || canOpenSubRoute(key, can);
}
